import React from 'react'
import LogInForm from '../components/LogInForm'

const LogIn = () => {
  return (
    <LogInForm/>
  )
}

export default LogIn